
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  handleSearch: (e: React.FormEvent) => void;
  placeholder?: string;
  buttonText?: string;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ 
  searchTerm, 
  setSearchTerm, 
  handleSearch,
  placeholder = "Search...",
  buttonText = "Search",
  className = "max-w-xl mb-8"
}) => {
  return (
    <form onSubmit={handleSearch} className={className}>
      <div className="relative flex">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground h-5 w-5" />
        <Input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-24 py-6 rounded-md border-eco-200 focus-visible:ring-eco-500"
        />
        <Button 
          type="submit" 
          className="absolute right-0 top-0 h-full rounded-r-md px-6 bg-eco-500 hover:bg-eco-600"
        >
          {buttonText}
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;
